import * as selectors from './copyPasteSelectors';

export { selectors };
